import { useEffect } from "react";

interface ToastProps {
  message: string;
  visible: boolean;
  onClose: () => void;
  icon?: string;
}

export default function Toast({ message, visible, onClose, icon = "ri-checkbox-circle-line" }: ToastProps) {
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(onClose, 2400);
    return () => clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-3 rounded-lg border border-primary-800 bg-primary-950 px-4 py-3 text-sm text-background-50 shadow-lg">
        <i className={`${icon} text-lg text-accent-400`} />
        <span className="flex-1">{message}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭提示"
          className="flex h-6 w-6 items-center justify-center text-background-400 transition-colors hover:text-background-50"
        >
          <i className="ri-close-line" />
        </button>
      </div>
    </div>
  );
}